import {
  GET_ALL_COATING_PUMPHOUSE,
  GET_ALL_COATING_PUMPHOUSE_SUCCESS,
  GET_ALL_COATING_PUMPHOUSE_FAILURE,
  CLEAR_COATING_PUMPHOUSE_DATA,
  BULK_SAVE_COATING_PUMPHOUSE,
  BULK_SAVE_COATING_PUMPHOUSE_SUCCESS,
  BULK_SAVE_COATING_PUMPHOUSE_FAILURE,
  CLEAR_BULK_SAVE_COATING_PUMPHOUSE,
  SAVE_PUMP_HOUSE_LIMIT_CONFIG,
  SAVE_PUMP_HOUSE_LIMIT_CONFIG_SUCCESS,
  SAVE_PUMP_HOUSE_LIMIT_CONFIG_FAILURE,
} from './types';

const initialState = {
  // GET all
  coatingPumphouseData: [],
  coatingPumphouseLoading: false,
  coatingPumphouseError: null,
  /** Last `getPumpHouseLimitConfig` result from get-all flow: { limits, active, projectId, pipeId } | null */
  pumpHouseLimitConfigFromApi: null,

  // POST bulk save
  bulkSaveLoading: false,
  bulkSaveSuccess: false,
  bulkSaveError: null,
  bulkSaveResult: null,

  pumpHouseLimitConfigSaveLoading: false,
  pumpHouseLimitConfigSaveError: null,
};

const coatingPumphouseReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_ALL_COATING_PUMPHOUSE:
      return {
        ...state,
        coatingPumphouseLoading: true,
        coatingPumphouseError: null,
        pumpHouseLimitConfigFromApi: null,
      };

    case GET_ALL_COATING_PUMPHOUSE_SUCCESS: {
      const p = action.payload;
      const rows = Array.isArray(p) ? p : (p?.rows ?? []);
      const limitConfig = Array.isArray(p) ? null : (p?.limitConfig ?? null);
      return {
        ...state,
        coatingPumphouseLoading: false,
        coatingPumphouseData: rows,
        coatingPumphouseError: null,
        pumpHouseLimitConfigFromApi: limitConfig,
      };
    }

    case GET_ALL_COATING_PUMPHOUSE_FAILURE:
      return {
        ...state,
        coatingPumphouseLoading: false,
        coatingPumphouseError: action.error,
        pumpHouseLimitConfigFromApi: null,
      };

    case CLEAR_COATING_PUMPHOUSE_DATA:
      return {
        ...state,
        coatingPumphouseData: [],
        coatingPumphouseError: null,
        pumpHouseLimitConfigFromApi: null,
      };

    case BULK_SAVE_COATING_PUMPHOUSE:
      return {
        ...state,
        bulkSaveLoading: true,
        bulkSaveSuccess: false,
        bulkSaveError: null,
        bulkSaveResult: null,
      };

    case BULK_SAVE_COATING_PUMPHOUSE_SUCCESS:
      return {
        ...state,
        bulkSaveLoading: false,
        bulkSaveSuccess: true,
        bulkSaveError: null,
        bulkSaveResult: action.payload,
      };

    case BULK_SAVE_COATING_PUMPHOUSE_FAILURE:
      return {
        ...state,
        bulkSaveLoading: false,
        bulkSaveSuccess: false,
        bulkSaveError: action.error,
      };

    case CLEAR_BULK_SAVE_COATING_PUMPHOUSE:
      return {
        ...state,
        bulkSaveLoading: false,
        bulkSaveSuccess: false,
        bulkSaveError: null,
        bulkSaveResult: null,
      };

    case SAVE_PUMP_HOUSE_LIMIT_CONFIG:
      return {
        ...state,
        pumpHouseLimitConfigSaveLoading: true,
        pumpHouseLimitConfigSaveError: null,
      };

    case SAVE_PUMP_HOUSE_LIMIT_CONFIG_SUCCESS:
      return {
        ...state,
        pumpHouseLimitConfigSaveLoading: false,
        pumpHouseLimitConfigSaveError: null,
        pumpHouseLimitConfigFromApi: action.payload?.limitConfig ?? state.pumpHouseLimitConfigFromApi,
      };

    case SAVE_PUMP_HOUSE_LIMIT_CONFIG_FAILURE:
      return {
        ...state,
        pumpHouseLimitConfigSaveLoading: false,
        pumpHouseLimitConfigSaveError: action.error,
      };

    default:
      return state;
  }
};

export default coatingPumphouseReducer;
